
import GenreMaker from '../anychart/genreMaker'; 

var MarkerChart = class MarkerChart extends GenreMaker {

    setData(state){
        console.log("entry marker");
        super.setData(state);
        var subGenre = this.getSubGenre();

        this.chart.xAxis();
        this.chart.yAxis();
        
        for (var series in this.data) {
            this.chart.marker(this.data[series]);
        }
    }

    createChart(){
        var chart = anychart.cartesian();
        return chart;
    }; 
};


    
GenreMaker.marker = MarkerChart;

export var MarkerChart;



// WEBPACK FOOTER //
// ./src/anychart/markerChart.js